import { DateTime } from "luxon";

/**
 * Where an order stands against its dispatch deadline, as the Orders table colours it.
 *
 * - overdue: not shipped and the deadline has passed (red).
 * - dueToday: not shipped, the deadline is today (UK) and has not passed yet (orange).
 * - null: shipped, no deadline (collections), or due on a later day.
 *
 * dispatchBy comes from the API as the end of a UK day in UTC (ShippingPolicyRules.DispatchBy),
 * so "today" is judged in Europe/London whatever the browser's timezone is.
 */
export type DispatchStatus = "overdue" | "dueToday" | null;

export function getDispatchStatus(
  dispatchBy: string | null | undefined,
  shippedOn: string | null | undefined,
  now: DateTime = DateTime.now()
): DispatchStatus {
  if (!dispatchBy || shippedOn) return null;

  const deadline = DateTime.fromISO(dispatchBy, { zone: "utc" });
  if (!deadline.isValid) return null;

  if (now > deadline) return "overdue";

  const ukNow = now.setZone("Europe/London");
  const ukDeadline = deadline.setZone("Europe/London");

  return ukDeadline.hasSame(ukNow, "day") ? "dueToday" : null;
}
